import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IEmailWorkflow extends IBaseEntity {
    id: number;
    entityId: number;
    type: any;
    subject: any;
    body: any;
    context: any;
    workflowConditions: any;
    notificationType: any;
    workflowUsers: any;
    wdaysOfWeek: any;
    mweekOfMonth: any;
    mmonthsOfYear: any;
    startTime: any;
    endTime: any;
    runInterval: any;
    scheduledAt: any;
    preBody: any;
    postBody: any;
    activated: any;
    emails: any;
    sendToCustomer: any;
    useLastUpdate: any;
    useCreatedOn: any;
    smsNumbers: any;
    whatsappNumbers: any;
    sendToSupplier: any;
    useEvent: any;
    generatePdf: any;
    generateCsv: any;
    csvSql: any;
    userLogin: any;
    mdaysOfMonth: any;
    senderEmail: any;
    useSchedule: any;
    replyToEmail: any;
    sqlQuery: any;
    allowResend: any;
}

export class EmailWorkflow extends BaseEntity implements IEmailWorkflow {
    id: number;
    body: any;
    context: any;
    entityId: number;
    subject: any;
    type: any;
    workflowConditions: any;
    notificationType: any;
    workflowUsers: any;
    wdaysOfWeek: any;
    mweekOfMonth: any;
    mmonthsOfYear: any;
    startTime: any;
    endTime: any;
    runInterval: any;
    scheduledAt: any;
    preBody: any;
    postBody: any;
    activated: any;
    emails: any;
    sendToCustomer: any;
    useLastUpdate: any;
    useCreatedOn: any;
    smsNumbers: any;
    whatsappNumbers: any;
    sendToSupplier: any;
    useEvent: any;
    generatePdf: any;
    generateCsv: any;
    csvSql: any;
    userLogin: any;
    mdaysOfMonth: any;
    senderEmail: any;
    useSchedule: any;
    replyToEmail: any;
    sqlQuery: any;
    allowResend: any;
    constructor(emailWorkflow?) {
        super();
        if (emailWorkflow) {
            this.id = emailWorkflow.id;
            this.body = emailWorkflow.body;
            this.context = emailWorkflow.context;
            this.entityId = emailWorkflow.entityId;
            this.subject = emailWorkflow.subject;
            this.type = emailWorkflow.type;
            this.notificationType = emailWorkflow.notificationType;
            this.workflowUsers = emailWorkflow.workflowUsers;
            this.workflowConditions = emailWorkflow.workflowConditions;
            this.wdaysOfWeek = emailWorkflow.wdaysOfWeek;
            this.mweekOfMonth = emailWorkflow.mweekOfMonth;
            this.mmonthsOfYear = emailWorkflow.mmonthsOfYear;
            this.startTime = emailWorkflow.startTime;
            this.endTime = emailWorkflow.endTime;
            this.runInterval = emailWorkflow.runInterval;
            this.scheduledAt = emailWorkflow.scheduledAt;
            this.preBody = emailWorkflow.preBody;
            this.postBody = emailWorkflow.postBody;
            this.activated = emailWorkflow.activated;
            this.emails = emailWorkflow.emails;
            this.sendToCustomer = emailWorkflow.sendToCustomer;
            this.useLastUpdate = emailWorkflow.useLastUpdate;
            this.useCreatedOn = emailWorkflow.useCreatedOn;
            this.useEvent = emailWorkflow.smsNumbers;
            this.useEvent = emailWorkflow.whatsappNumbers;
            this.useEvent = emailWorkflow.sendToSupplier;
            this.useEvent = emailWorkflow.useEvent;
            this.generatePdf = emailWorkflow.generatePdf;
            this.generateCsv = emailWorkflow.generateCsv;
            this.csvSql = emailWorkflow.csvSql;
            this.userLogin = emailWorkflow.userLogin;
            this.mdaysOfMonth = emailWorkflow.mdaysOfMonth;
            this.senderEmail = emailWorkflow.senderEmail;
            this.useSchedule = emailWorkflow.useSchedule;
            this.replyToEmail = emailWorkflow.replyToEmail;
            this.sqlQuery = emailWorkflow.sqlQuery;
            this.allowResend = emailWorkflow.allowResend;
        }
    }

    clone(): EmailWorkflow {
        return new EmailWorkflow(this);
    }
}
